import { map as rxjsmap } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { ActivityList, Repetition, Tasklist } from '../models';
import { BaseServices } from './../../kuba.services';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TaskService {
  constructor(private http: HttpClient) {}

  // get task using business id
  getAll(id: number) {
    return this.http
      .get(environment.BASE_URL + '/activities/' + id).pipe(rxjsmap(result => result));
  }
  getAllByEach(id: number, key: number) {
    return this.http
      .get<any>(
        `${environment.BASE_URL}/${BaseServices.apiRoute(
          key
        )}/task-manager/list/${id}`
      ).pipe(rxjsmap(result => result));
  }

  // Add deviation
  addActivity(activity: ActivityList, key: number) {
    return this.http
      .post(
        `${environment.BASE_URL}/${BaseServices.apiRoute(key)}/task-manager`,
        activity
      ).pipe(rxjsmap(result => result));
  }
  // for edit
  getById(id) {
    return this.http
      .get(environment.BASE_URL + '/activity/' + id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  // add task to list
  addTask(data): Observable<Repetition[]> {
    let body = JSON.stringify(data);
    return this.http
      .post(environment.BASE_URL + '/internalcontrol/task-manager', body).pipe(rxjsmap((res: any) => {
        return res;
      }));
  }

  // updating Task list
  updateTask(ExistingTask: ActivityList, key: string) {
    return this.http
      .put(
        `${environment.BASE_URL}/${BaseServices.apiRoute(key)}/task-manager`,
        ExistingTask
      ).pipe(rxjsmap(result => result));
  }

  // delete task from list
  deleteTask(Id) {
    return this.http
      .delete(environment.BASE_URL + '/activitydelete/' + Id).pipe(rxjsmap(result => result));
  }

  getTaskById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/activity/' + id).pipe(rxjsmap(result => result));
  }

  delete(id: number) {
    // let result: boolean;
    return this.http
      .delete(environment.BASE_URL + '/activitydelete/' + id).pipe(rxjsmap(result => result));
  }

  deleteParentwithRecurring(id: number) {
    return this.http
      .delete(
        environment.BASE_URL + '/followup' + '/deleteParentwithRecurring/' + id
      ).pipe(rxjsmap(result => result));
  }

  // bind repetition dropdown
  getAllRepeat() {
    return this.http
      .get(environment.BASE_URL + '/repetition').pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  // bind  execution dropdown
  getAllExce(id: number) {
    return this.http
      .get(environment.BASE_URL + '/employees/' + id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  // bind followup dropdown
  getAllFollow(id: number) {
    return this.http
      .get(environment.BASE_URL + '/employees/' + id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  private extractData(res: any) {
    let body = res; // return body || {};
    return <Tasklist[]>res.json();
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
  getActivityLog(id: number) {
    return this.http
      .get(`${environment.BASE_URL}/project/task-manager-log/${id}`).pipe(rxjsmap(result => result));
  }

  getTaskManagerAuditLog(id: number, internalControlId: number, key: string) {
    return this.http
      .get(
        `${environment.BASE_URL}/${BaseServices.apiRoute(
          key
        )}/task-manager-auditlog/${id}/${internalControlId}`
      ).pipe(rxjsmap((result: any) => result));
  }
  deleteActivityAttachment(Id) {
    return this.http
      .delete(environment.BASE_URL + '/deleteactivityattachment/' + Id).pipe(rxjsmap(result => result));
  }

  getCheckListData(businessId: number, featureId: number, featurekey: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/feature/checklist/GetAllCheckList/${businessId}/${featureId}/${featurekey}`
      ).pipe(rxjsmap(result => result));
  }

  /**
   *
   * @param activityId
   */
  checkParentActivity(activityId: number) {
    return this.http
      .get(environment.BASE_URL + '/followup' + '/parentActivity/' + activityId).pipe(rxjsmap(result => result));
  }

  getActivityCompleteCheckList(activityId: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/features/FeatureManualComplete/get/checklistByActivity/' +
          activityId
      ).pipe(rxjsmap(result => result));
  }

  getFeatureChecklistItems(chkId: number) {
    return this.http
      .get(environment.BASE_URL + '/feature/checklist/checklist/' + chkId).pipe(rxjsmap(result => result));
  }

  /**
   * stop future recurring
   * @param activityId
   */
  stopFutureRecurring(activityId) {
    return this.http
      .get(environment.BASE_URL + '/stopFutureRecurringActivity/' + activityId).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  getAssignedUsers(
    businessId: number,
    featureId: number,
    featurekey: number,
    applicationId: number
  ) {
    return this.http
      .get(
        `${environment.BASE_URL}/AssingedUsers/${businessId}/${featurekey}/${featureId}/${applicationId}`
      ).pipe(rxjsmap(result => result));
  }

  getCheckList(featureId: number, featurekey: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/foodsafety/checklist/' +
          featureId +
          '/' +
          featurekey
      ).pipe(rxjsmap(result => result));
  }

  StopWeekFutureRecurrTask(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/stopweekfuturerecurrtask/' + Id).pipe(rxjsmap(result => result));
  }

  CompleteFSTask(Id: any, UserId: number) {
    return this.http
      .get(
        environment.BASE_URL + '/foodsafety/completefstask/' + Id + '/' + UserId
      ).pipe(rxjsmap(result => result));
  }

  deleteParentwithRecurringFS(id: number) {
    return this.http
      .delete(
        environment.BASE_URL + '/foodsafety/deleteParentwithRecurring-fs/' + id
      ).pipe(rxjsmap(result => result));
  }
}
